module.exports = __webpack_public_path__ + "static/media/platform_mannual_en.a142949f.md";